import { AppBar, AppBarConteudoDefault } from "features/layout";
import { NavegacaoTabs } from "features/navegacao";
import { SelectedFarmContainer } from "features/shared/crossCuttingComponents";
import React from "react";
import { withStyles } from "@material-ui/core";

const AppBarTitle = () => {
  return (
    <SelectedFarmContainer
      render={(fazenda, { noFarmSelectedTitle }) => {
        const textoSecundarioAppBar = fazenda
          ? fazenda.NomeReduzido
          : noFarmSelectedTitle;
        return <AppBarConteudoDefault tituloAppBar={textoSecundarioAppBar} />;
      }}
    />
  );
};

const tabs = [
  {
    label: "Histórico de movimentações de rebanho",
    id: "historico_movimentacao_aplicativo",
    show: true,
  },
  {
    label: "Movimentações pendentes",
    id: "movimentacoesPendentes",
    show: true,
  },
];

const getTabByPath = (path) => {
  const id = path.split("/").pop();
  return id;
};

const ContainerMovements = ({ classes, history, match, children }) => {
  const selectedTab = getTabByPath(match.path);

  const clickTab = (event) => {
    history.push(`/${event.currentTarget.id}`);
  };

  return (
    <>
      <AppBar conteudoCustomizadoAppBar={AppBarTitle()} preventPadding={true} />
      <NavegacaoTabs
        tabs={tabs}
        mudarTab={clickTab}
        estilosTab={{
          fontSize: 16,
          height: 60,
        }}
        abaSelecionada={selectedTab}
        styles={{
          backgroundColor: "#f8f8f8",
          display: "flex",
        }}
        fullWidth={true}
        justify="flex-start"
      />
      <div className={classes.rootPendency}>{children}</div>
    </>
  );
};

const styles = () => ({
  rootPendency: {
    paddingTop: "60px",
  },
});

export default withStyles(styles)(ContainerMovements);
